module.exports = __webpack_public_path__ + "img/9788964371930.a333c05c.jpg";